import { IndexPage } from "route-components/IndexPage";
import { createFileRoute } from "@tanstack/react-router";
import { validateStripeParams } from "utils/validateStripeParams";
import type { PatientPortalPatientLoginCredentials } from "api/VynePayments/requests";

/** Route for the index page, which is only used for either legacy links using search parameters or Stripe redirects. */
export const Route = createFileRoute("/")({
    validateSearch: (search) => {
        if (typeof search.token === "string" && search.token) {
            const credentials: PatientPortalPatientLoginCredentials = {
                token: search.token,
                channel: typeof search.channel === "string" ? search.channel : null,
            };

            return credentials;
        }

        return validateStripeParams(search);
    },
    component: IndexPage,
});
